const AspectOutputAttributeClass = {
	ENERGY: 'Energy',
	COMPONENT_LIST: 'Component list',
	STREAM_PROPERTY: 'Stream property',
	KPI: 'Kpi'
};

export default AspectOutputAttributeClass;
